"use client";

import { motion } from "framer-motion";
import StarsBackground from "../../about-us/parts/StarsBackground";

// Reuse Our Story's three-layer starfield, independent of the Portfolio burst.
export default function HeroStars({ visible }) {
  return (
    <motion.div data-hero-stars className="absolute inset-0" initial={false}
      animate={{ opacity: visible ? 1 : 0 }} transition={{ duration: 0.5 }}>
      <StarsBackground className="!bg-none" factor={0} />
    </motion.div>
  );
}
